import { useEffect, useMemo } from 'react'

import { useOrgCompliance } from '~/hooks/compliance'
import { useFuzzySearch } from '~/hooks/useFuzzySearch'
import { AddressSearchResult } from '~/types'

export function usePayeeSearch(queryInput: string) {
  const { payees, query: complianceQuery } = useOrgCompliance()

  const { updateFilter, results } = useFuzzySearch(payees, (payee) => [
    { data: payee.payeeOrg?.name, type: 'inclusion' },
    {
      data: payee.payeeOrg?.name,
      type: 'levenshtein',
      distanceThreshold: 0.7,
    },
  ])

  useEffect(() => {
    updateFilter(queryInput)
  }, [queryInput, updateFilter])

  const addressSearchResults = useMemo<AddressSearchResult[]>(() => {
    return results
      .filter((payee) => payee.address && payee.chains)
      .map((payee) => ({
        address: payee.address!,
        payee: {
          payeeOrg: payee.payeeOrg,
          payeeInvitedUserId: payee.payeeInvitedUserId,
          payeeInvitedEmail: payee.payeeInvitedEmail,
        },
      }))
  }, [results])

  return {
    results: addressSearchResults,
    isLoading: complianceQuery.isLoading,
  }
}
